import { Image, View } from "@/components/ui";
import { Typography } from "@/components/shared/typography";
import { useMemo } from "react";
import { useWindowDimensions } from "@/components/hooks/use-window-dimension";

export function EmptyCard({
  title,
  src,
  desc,
}: {
  title: string;
  src: string;
  desc?: string;
}) {
  const { isMobile } = useWindowDimensions();
  const width = useMemo(() => {
    return isMobile ? 104 : 140;
  }, [isMobile]);
  return (
    <View className="flex flex-col items-center gap-4 py-8">
      <Image src={src} width={width} height={width} />
      <View className="flex flex-col items-center gap-2">
        <Typography variant="label-lg">{title}</Typography>
        {desc && (
          <Typography
            variant="label-md"
            color="foreground-intermediate"
            className="text-center"
          >
            {desc}
          </Typography>
        )}
      </View>
    </View>
  );
}
